import type { ErrorContext, ServiceName } from "./envelope"
import { buildSentryEnvelope, isExpectedIntegrationError } from "./envelope"

export * from "./envelope"
export * from "./report-once"

type CaptureExceptionFn = (
	exception: unknown,
	captureContext?: {
		tags?: Record<string, string>
		extra?: Record<string, unknown>
		fingerprint?: string[]
	},
) => string

/**
 * Build a runtime-bound captureError. Each app passes its own SDK's captureException
 * (@sentry/node, @sentry/nextjs, @sentry/react) and the service it runs as, so every
 * event carries a consistent envelope plus a `service` tag for per-deployable filtering.
 */
export function createCaptureError(
	captureException: CaptureExceptionFn,
	service?: ServiceName,
) {
	return function captureError(error: unknown, context: ErrorContext): void {
		if (isExpectedIntegrationError(error)) return
		const { error: titled, captureContext } = buildSentryEnvelope(
			error,
			context,
			service,
		)
		captureException(titled, captureContext)
	}
}
